import { useEffect } from 'react';

interface SeoJsonLdProps {
  data: Record<string, unknown> | Record<string, unknown>[];
  id: string;
}

export default function SeoJsonLd({ data, id }: SeoJsonLdProps) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [data, id]);

  return null;
}
